import * as React from 'react';
let refCount = 0;
let refTopOffset = 0;
export class ScrollLock extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.isIos = false;
        this.currentRef = null;
    }
    enable() {
        refCount += 1;
        this.currentRef = {
            getElement: () => (this.props?.getElement != null
                ? this.props?.getElement()
                : null),
        };
        if (refCount === 1) {
            const documentWidth = document.documentElement.clientWidth;
            const windowWidth = window.innerWidth;
            const scrollBarWidth = windowWidth - documentWidth;
            document.body.style.paddingRight = `${scrollBarWidth}px`;
            document.body.style.overflow = 'hidden';
            // Implement scroll prevention specially for iOS devices
            if (this.isIos) {
                refTopOffset = window.scrollY;
                const html = document.querySelector('html');
                if (html) {
                    html.style.height = `${window.innerHeight - 1}px`;
                }
                document.body.style.position = 'fixed';
                document.body.style.top = `-${refTopOffset}px`;
                document.body.style.left = '0';
                document.body.style.right = '0';
            }
        }
    }
    disable() {
        refCount -= 1;
        if (refCount === 0) {
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
            if (this.isIos) {
                document.body.style.position = 'static';
                window.scrollTo(0, refTopOffset);
            }
        }
    }
    componentDidMount() {
        const { enabled } = this.props;
        this.isIos = !!navigator.userAgent.match(/iPad|iPhone|iPod/gi);
        if (enabled) {
            this.enable();
        }
    }
    componentDidUpdate(prevProps) {
        const { enabled } = this.props;
        if (enabled !== prevProps.enabled) {
            if (enabled) {
                this.enable();
            }
            else {
                this.disable();
            }
        }
    }
    componentWillUnmount() {
        const { enabled } = this.props;
        if (enabled) {
            this.disable();
        }
    }
    render() {
        return null;
    }
}
//# sourceMappingURL=ScrollLock.js.map